import {Box, Divider, Flex, Heading, Link, Stack, Text, useColorMode, useColorModeValue, VStack} from '@chakra-ui/react'
import Image from 'next/image'
import {BsFillTelephoneFill as PhoneIcon} from 'react-icons/bs'
import {MdEmail as EmailIcon} from 'react-icons/md'

import providerLogoWhite from '../../public/GCM-logo.svg'
import providerLogoDark from '../../public/GCM-logo-dark.svg'
import BMLogoBox from "../BMLogo/BMLogoBox";

export function Footer(props) {
    const {providerName, providerEmail, providerPhoneNumber, providerAddress} = props
    const providerPhoneNumberLink = `tel:${providerPhoneNumber}`
    const providerEmailLink = `mailto:${providerEmail}`

    const { colorMode } = useColorMode()
    const FooterBG = useColorModeValue('#E8ECED', '#2F2F2F')
    const IconColor = useColorModeValue('black', 'white')
    return (
        <Box bg={FooterBG} mb={{base: '4.5rem', md: '0'}}>
            <Flex
                maxW='1024px'
                mx='auto'
                as="section"
                direction={{base: 'column', sm: 'row'}}
                justifyContent='space-between'
                align="center"
                p={{base: "2", sm: "4", md: "8"}}
            >
                <VStack align='flex-start' spacing={1} p={4}>
                    <Heading fontSize='2xl' fontWeight='bold'> Questions? </Heading>
                    <Stack direction='row' align='center'>
                        <Box pt={2} pb={2}>
                            <PhoneIcon size="18px" color={IconColor}/>
                        </Box>
                        <Link as='a' href={providerPhoneNumberLink} fontSize={{base: 'lg', lg: 'xl'}} fontWeight='bold'>
                            {providerPhoneNumber}
                        </Link>
                    </Stack>
                    <Stack direction='row' align='center'>
                        <Box pt={2} pb={2}>
                            <EmailIcon size="18px" color={IconColor}/>
                        </Box>
                        <Link as='a' href={providerEmailLink} fontSize={{base: 'lg', lg: 'xl'}} fontWeight='bold'>
                            {providerEmail}
                        </Link>
                    </Stack>
                </VStack>
                <Box display={{base: 'block', sm: 'none'}} pl={8} pr={8} pt={2} pb={2} w='100%'>
                    <Divider variant='dashed' borderColor='#BABABA'/>
                </Box>
                <VStack p={4}>
                    <Image src={useColorModeValue(providerLogoDark, providerLogoWhite)} height={74} width={300} alt="Provider Logo"/>
                    <BMLogoBox imageHeight={37} imageWidth={36} colorMode={colorMode}>
                        <Text> Powered by <b>BoutiqueMate®</b> </Text>
                    </BMLogoBox>
                </VStack>
            </Flex>
        </Box>
    )
}